// append new messages to old message, new messageList might have duplicate
// message from old list. Then return the final list.
export const combineTwoMessageList = (
  oldMessageList: any,
  newMessageList: any,
) => {
  if (oldMessageList && oldMessageList.length === 0) {
    return newMessageList;
  }

  const oldMessageListCopy = [...oldMessageList];

  const oldIds: any = [];
  const diff: any = [];
  for (const currMessage of oldMessageListCopy) {
    oldIds.push(currMessage.id);
  }

  for (const currMessage of newMessageList) {
    const index = oldIds.indexOf(currMessage.id);
    if (index === -1) {
      diff.push(currMessage);
    } else {
      /**
       * The new message that arrived must override a given oldMessage
       * (new message might contain updated data/fields)
       */
      oldMessageListCopy[index] = currMessage;
    }
  }

  const resList = oldMessageListCopy.concat(diff);
  return resList;
};
